import Vue from "vue";
import Router from "vue-router";
// session components
import AppLanding from "@/router/views/account/AppLanding.vue";
import TenantGateway from "@/router/views/account/TenantGateway.vue";
import DashBoard from "@/router/views/dashboards/default.vue";
import Profile from "./views/account/UserProfile.vue";
import SessionTimeOut from "./views/account/SessionTimeOut.vue";
import ForgotPassword from "./views/account/ForgotPassword.vue";
import NotFound from "@/router/views/shared/NotFound.vue";
import UserLogins from "@/router/views/analytics/UserLogins.vue";
Vue.use(Router);
export default new Router({
    routes: [
        {
            name: "default",
            path: "/",
            component: AppLanding,
            meta: {
                publicPage: true,
                tenantAgnostic: true,
            },
        },
        {
            name: "SessionTimeOut",
            path: "/sessiontimeout",
            component: SessionTimeOut,
            meta: {
                publicPage: true,
                tenantAgnostic: true,
            },
        },
        {
            name: "ForgotPassword",
            path: "/forgotpassword",
            component: ForgotPassword,
            meta: {
                publicPage: true,
                tenantAgnostic: true,
            },
        },
        {
            name: "TenantGateway",
            path: "/tenant-gateway",
            component: TenantGateway,
            meta: {
                tenantAgnostic: true,
            },
        },
        {
            name: "DashBoard",
            path: "/dashBoard",
            component: DashBoard,
            meta: {},
        },
        {
            name: "Profile",
            path: "/profile",
            component: Profile,
            meta: {},
        },
        {
            name: "NotFound",
            path: "*",
            component: NotFound,
            meta: {},
        },
        {
            component: UserLogins,
            path: "/user-Logins",
            name: "UserLogins",
            meta: {},
        },
        /* Users */
        {
            name: "Users",
            path: "/users",
            component: () => import(/* webpackChunkName: "Users" */ "@/router/views/users/UsersList.vue"),
            meta: {},
        },
        {
            name: "AddUser",
            path: "/users/add",
            component: () => import(/* webpackChunkName: "Users" */ "@/router/views/users/AddUser.vue"),
            meta: {},
        },
        {
            name: "EditUser",
            path: "/users/edit/:userId",
            component: () => import(/* webpackChunkName: "Users" */ "@/router/views/users/EditUser.vue"),
            meta: {},
        },
        {
            name: "ViewUser",
            path: "/users/view/:userId",
            component: () => import(/* webpackChunkName: "Users" */ "@/router/views/users/ViewUser.vue"),
            meta: {},
        },
        {
            name: "ListManager",
            path: "/listManager",
            component: () => import(/* webpackChunkName: "Projects"*/ "@/router/views/listManager/ListManager.vue"),
            meta: {},
        },
        {
            name: "Categories",
            path: "/categories",
            component: () => import(/* webpackChunkName: "Categories" */ "@/router/views/categories/Categories.vue"),
            meta: {},
        },
        //Page Manager
        {
            name: "PageManager",
            path: "/pages",
            props: true,
            component: () => import(/* webpackChunkName: "PageManager" */ "@/router/views/page-manager/Pages.vue"),
            meta: {},
        },
        //Menu Manager
        {
            name: "MenuManager",
            path: "/menu",
            props: true,
            component: () => import(/* webpackChunkName: "MenuManager" */ "@/router/views/menu-manager/menu.vue"),
            meta: {},
        },
        //Script Manager
        {
            name: "ScriptManager",
            path: "/script",
            props: true,
            component: () => import(/* webpackChunkName: "ScriptManager" */ "@/router/views/script-manager/ScriptManager.vue"),
            meta: {},
        },
        //Role Manager
        {
            name: "RoleManager",
            path: "/role",
            props: true,
            component: () => import(/* webpackChunkName: "Role" */ "@/router/views/roles/RolesManager.vue"),
            meta: {},
        },
        {
            name: "Notification",
            path: "/notifications",
            props: true,
            component: () => import(/* webpackChunkName: "Notification" */ "@/router/views/notification/Notification.vue"),
            meta: {},
        },
        // Tags
        {
            name: "TagsListing",
            path: "/reportTags",
            component: () => import(/* webpackChunkName: "Tags" */ "@/router/views/tags/TagsList.vue"),
            meta: {},
        },
        {
            name: "Highlights",
            path: "/highlights",
            component: () => import(/* webpackChunkName: "Highlights" */ "@/router/views/highlights/Highlights.vue"),
            meta: {},
        },
        {
            name: "CreateHighlights",
            path: "/highlights/add",
            component: () => import(/* webpackChunkName: "CreateHighlights" */ "@/router/views/highlights/CreateHighlights.vue"),
            meta: {},
        },
        {
            name: "EditHighlight",
            path: "/highlights/edit/:highlightId",
            component: () => import(/* webpackChunkName: "EditHighlights" */ "@/router/views/highlights/EditHighlights.vue"),
            meta: {},
        },
        {
            name: "ViewHighlight",
            path: "/highlights/view/:highlightId",
            component: () => import(/* webpackChunkName: "EditHighlights" */ "@/router/views/highlights/ViewHighlights.vue"),
            meta: {},
        },
        {
            name: "PolicyHighlights",
            path: "/policyHighlights",
            component: () => import(/* webpackChunkName: "PolicyHighlights" */ "@/router/views/highlightView/PolicyHighlights.vue"),
            meta: {},
        },
        // States
        {
            name: "StatesListing",
            path: "/states",
            component: () => import(/* webpackChunkName: "States" */ "@/router/views/states/StatesList.vue"),
            meta: {},
        },
        // Entries
        {
            name: "EntryListing",
            path: "/entries",
            component: () => import("@/router/views/entry/EntryList.vue"),
            meta: {},
        },
        {
            name: "AddEntry",
            path: "/entries/add",
            component: () => import(/* webpackChunkName: "Add Entry" */ "@/router/views/entry/AddEntry.vue"),
            meta: {},
        },
        {
            name: "EditEntry",
            path: "/entries/edit/:entryId",
            component: () => import(/* webpackChunkName: "Edit Entry" */ "@/router/views/entry/EditEntry.vue"),
            meta: {},
        },
        {
            name: "ViewEntry",
            path: "/entries/view/:entryId",
            component: () => import(/* webpackChunkName: "View Entry" */ "@/router/views/entry/ViewEntry.vue"),
            meta: {},
        },
        //Organizations
        {
            name: "Organizations",
            path: "/organizations",
            component: () => import(/* webpackChunkName: "View Entry" */ "@/router/views/organization/Organization.vue"),
            meta: {},
        },
        {
            name: "AddOrganization",
            path: "/organizations/add",
            component: () => import(/* webpackChunkName: "View Entry" */ "@/router/views/organization/AddOrganization.vue"),
            meta: {},
        },
        {
            name: "EditOrganization",
            path: "/organizations/edit/:organizationId",
            component: () => import(/* webpackChunkName: "View Entry" */ "@/router/views/organization/EditOrganization.vue"),
            meta: {},
        },
        {
            name: "ViewOrganization",
            path: "/organizations/view/:organizationId",
            component: () => import(/* webpackChunkName: "View Entry" */ "@/router/views/organization/ViewOrganization.vue"),
            meta: {},
        },
        {
            name: "CalendarEvents",
            path: "/calendarEvents",
            component: () => import(/* webpackChunkName: "CalendarEvent" */ "@/router/views/calendarEvents/CalendarEvents.vue"),
            meta: {},
        },
        {
            name: "CreateCalendarEvent",
            path: "/calendarEvents/add",
            component: () => import(/* webpackChunkName: "CreateCalendarEvent" */ "@/router/views/calendarEvents/CreateCalendarEvent.vue"),
            meta: {},
        },
        {
            name: "EditCalendarEvent",
            path: "/calendarEvents/edit/:calendarEventId",
            component: () => import(/* webpackChunkName: "CreateCalendarEvent" */ "@/router/views/calendarEvents/EditCalendarEvent.vue"),
            meta: {},
        },
        {
            name: "Calendar",
            path: "/calendar",
            component: () => import(/* webpackChunkName: "Calendar" */ "@/router/views/calendar/Calendar.vue"),
            meta: {},
        },
        {
            name: "FileManager",
            path: "/fileManager",
            component: () => import(/* webpackChunkName: "Calendar" */ "@/router/views/fileManager/FileUpload.vue"),
            meta: {},
        },
        {
            name: "Automations",
            path: "/automations",
            component: () => import(/* webpackChunkName: "Calendar" */ "@/router/views/automation/Automation.vue"),
            meta: {},
        },
        {
            name: "AddAutomation",
            path: "/automation/add",
            component: () => import(/* webpackChunkName: "AddAutomation" */ "@/router/views/automation/AddAutomation.vue"),
            meta: {},
        },
        {
            name: "ViewAutomation",
            path: "/automation/view/:automationId",
            component: () => import(/* webpackChunkName: "AddAutomation" */ "@/router/views/automation/ViewAutomation.vue"),
            meta: {},
        },
    ],
    // Use the HTML5 history API (i.e. normal-looking routes)
    // instead of routes with hashes (e.g. example.com/#/about).
    // This may require some server configuration in production:
    // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
    mode: "history",
    // Simulate native-like scroll behavior when navigating to a new
    // route and using back/forward buttons.
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        }
        else {
            return { x: 0, y: 0 };
        }
    },
});
